import { SET_LANGUAGE } from '../constants/actionTypes.js';

//++++++++++++++++++SET LANGUAGE+++++++++++++++++++++++
export const setLanguage = (language) => async (dispatch) => {

    //Set the language in navigation menu. Is used in whole application.
    dispatch({ type: SET_LANGUAGE, payload: language });
  
}